module.exports = __webpack_public_path__ + "static/images/notification.891a11e184e6e3ad4c42d2d6c8aca6d9.svg";